import FetchError from '../FetchError';
import {
    getResponseInterceptorHandlers,
    getErrorHandlers,
} from '../interceptors';
import {
    ABORT_ERROR,
    FETCH_ERROR,
    RESPONSE_ERROR,
    TIMEDOUT_ERROR,
} from './constants';

const isJSONResponse = (contentType) => {
    return contentType && contentType.indexOf('application/json') !== -1;
};

const isTextResponse = (contentType) => {
    return contentType && contentType.indexOf('text/') === 0;
};

const handleResponse = async (httpResponse, fetchConfig) => {
    let responseData;

    let response = httpResponse;

    const responseInterceptorHandlers = getResponseInterceptorHandlers();

    for (let i = 0; i < responseInterceptorHandlers.length; i += 1) {
        response =
            // eslint-disable-next-line no-await-in-loop
            (await responseInterceptorHandlers[i].interceptorHandler(
                response,
                fetchConfig,
            )) ?? response;

        if (!(response instanceof Response)) {
            const blob = new Blob([JSON.stringify(response)], {
                type: 'application/json',
            });

            const headers = { status: 200, statusText: 'OK' };
            response = new Response(blob, headers);
        }
    }

    const { headers: responseHeaders = {}, status } = response;

    const contentType = responseHeaders.get('content-type');

    if (isJSONResponse(contentType)) {
        responseData = await response.json();
    } else if (isTextResponse(contentType)) {
        responseData = await response.text();
    } else {
        responseData = response;
    }

    if (!response.ok) {
        throw new FetchError({
            type: RESPONSE_ERROR,
            response,
            responseData,
            status,
        });
    }

    return responseData;
};

export const handleError = (err, requestTimedout) => {
    const errorHandlers = getErrorHandlers();
    const eventParam = { error: err, preventDefault: false };

    for (let i = 0; i < errorHandlers.length; i += 1) {
        const { errorHandler } = errorHandlers[i];

        errorHandler(eventParam);

        if (eventParam.preventDefault === true) {
            return;
        }
    }

    if (err instanceof FetchError) {
        throw err;
    }

    if (err.name === 'AbortError') {
        if (requestTimedout) {
            throw new FetchError({
                type: TIMEDOUT_ERROR,
            });
        } else {
            throw new FetchError({
                type: ABORT_ERROR,
            });
        }
    }

    throw new FetchError({
        type: FETCH_ERROR,
    });
};

export default handleResponse;
